import type { ReactNode } from 'react';
import { cn } from './utils';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-dashed border-zinc-200 bg-white px-6 py-12 text-center',
        className,
      )}
    >
      {icon !== undefined && icon !== null ? (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-zinc-100 text-zinc-500">
          {icon}
        </div>
      ) : null}
      <h3 className="text-base font-semibold text-zinc-900">{title}</h3>
      {description !== undefined && description !== null ? (
        <p className="mt-1 max-w-sm text-sm text-zinc-500">{description}</p>
      ) : null}
      {action !== undefined && action !== null ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
